import { useState } from "react";
import { useHistory } from "react-router-dom";
import useUrlNavigation from "hooks/useUrlNavigation";
import useUrlQueryParams from "hooks/useUrlQueryParams";
import iconSearch from "assets/images/icons/icon-search.svg";


export function SearchBox(props) {
  const {urlQuery} = useUrlNavigation();
  const {urlQueryParams} = useUrlQueryParams();
  const history = useHistory();

  const extraUrlParams = props.extraUrlParams ? "&" + props.extraUrlParams : "";
  
  const searchQuery = urlQueryParams[props.name];
  const [search, setSearch] = useState(searchQuery || "");

  const submitForm = async (e) => {
    e.preventDefault();
    history.push(urlQuery(props.name + "=" + search + extraUrlParams));
  }
  
  const handleInputChange = (e) => {
    const { value } = e.target;
    !value && history.push("?");
    setSearch(value);
  }

  return (
    <form onSubmit={submitForm} className="">
      <div className="form-group mb-0">
        <div className="form-group-icon h-10 rounded-xl bg-[#F6F6F6] border-none">
          <label htmlFor="search">
            <img src={iconSearch} alt="Search" className="form-group-icon-attach h-4" />
          </label>
          <input
            type="search"
            id="search"
            name={props.name}
            value={search}
            onChange={handleInputChange}
            placeholder={props.placeholder}
            className="min-w-[200px] h-full form-input-icon bg-[#F6F6F6] focus:ring-transparent"
            style={{paddingLeft: "0", border: "none", outline: "none", fontFamily: 'Aeonik'}}
          />
        </div>
      </div>
    </form>
  );
}

export default SearchBox;
